import * as React from 'react';
import { routeConstants } from 'app/routes/route-constants';
import { serializeConnectionState } from 'app/area/case/draft/connected-state';
import * as navigate from 'app/area/shared/navigation';
import { nextSequenceValue } from 'app/area/case/features/connected-cases/sequence';
import { STATE } from 'app/constants';

/**
 * This interface is used by the wrapped component to know what to expect from this higher-order component.
 */
export interface NavigateToNewDraftInjectedProps {
  navigateToNewDraft: () => void;
}

interface NavigateToNewDraftProps {
  entityId: number;
  caseType: number;
  connectionTypeId: number;
  maxSequence: number;
  connectedDrafts?: any[];
  path?: any[];
}

/**
 * Provides property to navigate to a new draft of the provided case type.
 */
export const withNavigateToNewDraft = <P extends {}>(
  WrappedComponent: (React.ComponentClass<P & NavigateToNewDraftInjectedProps> | React.FC<P & NavigateToNewDraftInjectedProps>), 
  useReverseConnection: boolean = false
): React.ComponentClass<P & NavigateToNewDraftProps> => {
  return class extends React.PureComponent<P & NavigateToNewDraftProps> {
    public static statePath: string = STATE.app;

    private getNextSequenceValue = () => nextSequenceValue(this.props.maxSequence);

    private navigateToNewDraft = () => {
      const { entityId: draftId, caseType, connectionTypeId, connectedDrafts = [], resolveContext, path } = this.props as any;
      const entityId = useReverseConnection ? 'caseId' : 'draftId';
      caseType &&
        navigate.to({
          pathname: routeConstants.createCase(caseType),
          search: serializeConnectionState([
            {[entityId]: draftId, connectionTypeId, sequence: this.getNextSequenceValue() },
            ...connectedDrafts
          ])
        },
        {
          state: { internal: true, entityPath: resolveContext?.path || path }
        });
    };

    public render() {
      return (
        <WrappedComponent {...this.props} navigateToNewDraft={this.navigateToNewDraft} useReverseConnection={useReverseConnection}/>
      );
    }
  };
};
